<template>
  <div class="product-flags">
    <flags
      :flags="flags"
      :limit="limit"
      :award-limit="awardLimit"
      :white-list="whiteList && whiteList.length > 0 ? whiteList : settings.flags.whitelist"
      :lazy-load="false"
      :enable-links="true"
      :target-blank-flags="targetBlankFlags"
      :with-savings-max="withSavingsMax"
      @click="clickHandler"
    />
  </div>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import * as scrollToElement from 'scroll-to-element';
  import productStore, {ProductStore} from '../../stores/product/ProductStore';
  import diContainer from '../../utilities/js/diContainer/diContainer';
  import {ProductDetailsSettings} from '../productDetails/productDetailsSettings';
  import type Flags from '../../types/Flags';
  import breakpoints from '../../variables/js/breakpoints.js';

  @Options({
    name: 'product-flags',
  })
  export default class ProductFlags extends Vue {
    @Prop()
    readonly fixAwardLimit: number;
    @Prop()
    readonly whiteList: string[];
    @Prop()
    readonly limitMobile: number;
    @Prop()
    readonly limitDesktop: number;
    @Prop({type: Array})
    readonly targetBlankFlags: string[];

    productStore: ProductStore = productStore;
    settings: ProductDetailsSettings = diContainer.get('productDetailsSettings');

    get flags(): Flags {
      return this.productStore.productDetails.flags;
    }

    get withSavingsMax(): boolean {
      return this.productStore.productDetails.pageType === 'AQ_LANDING_PAGE' || this.productStore.productDetails.pageType === 'DISPLAY_LANDING_PAGE';
    }

    get limit(): number {
      return this.isMobile() ? this.limitMobile : this.limitDesktop;
    }

    get awardLimit(): number {
      if (this.fixAwardLimit) {
        return this.fixAwardLimit;
      }
      return (this.flags.new && this.flags.savings && this.flags.bio && this.flags.vegan) ? 2 : 3;
    }

    isMobile() {
      return window.innerWidth < breakpoints.tablet;
    }

    clickHandler(flag) {
      if (flag.type === 'AWARD') {
        scrollToElement('.product-awards', {
          offset: -255
        });
      }
    }
  }
</script>
